"use client";
// @ts-strict-ignore
import styled from "styled-components";

export const StyledTable = styled.div`
  table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    text-align: left;
    margin-top: 24px;
    margin-bottom: 24px;

    th {
      font-weight: ${({ theme }) => theme.fontWeight.semiBold};
      color: ${({ theme }) => theme.textColors.secondary};
      text-transform: uppercase;
      padding: 16px 16px 16px 0;
    }

    tr {
      border-bottom: 1px solid ${({ theme }) => theme.borderColors.primary};
    }

    td {
      font-size: 14px;
      padding: 16px 16px 16px 0;
    }
  }
`;
